import request from "utils/request";

export async function getTeacherList(url = "", nocache = "nocache") {
  return request.get(url, nocache);
}

export async function getMyTeacher(keyword, nocache = "nocache") {
  const url = keyword
    ? `/teachers/favoriteTeachersv2.php?keyword=${keyword}`
    : "/teachers/favoriteTeachersv2.php";
  return request.get(url, nocache);
}

export async function setMyTeacher(data) {
  return request.post("/teachers/favoriteTeachersv2.php", data, "nocache");
}

export async function getSpeakAudio({ token, text, voice_id }) {
  return request.post(
    `/teachers/speakAudiov2.php?token=${token}&text=${text}&voice_id=${voice_id}`,
    "nocache"
  );
}

export async function getAudioInfo(data) {
  return request.post("/teachers/audioInfo.php", data, "nocache");
}

export async function teacherIntroduction(data) {
  return request.post("/teachers/teacherIntroduction.php", data, "nocache");
}

export async function elevebLabsTeacherv2(keyword) {
  return request.get(
    `/teachers/elevebLabsTeacherv2.php?keyword=${keyword || ""}`,
    "nocache"
  );
}
